import {
  IMauPhieuThuCauHinh,
  IMauPhieuThuCauHinhCreateRequest,
  IMauPhieuThuCauHinhUpdateRequest,
  IMauPhieuThuApDungRequest,
} from "../../model/respone/category/IMauPhieuThuCauHinh";
import { apiClient } from "../apiClient";

const API_BASE = "mau-phieu-thu-cau-hinh";

export const mauPhieuThuCauHinhApi = {
  selectAll: () => apiClient.get(API_BASE),
  selectById: (id: number) => apiClient.get(`${API_BASE}/${id}`),
  selectByTemplateGoc: (id_template_goc: number) =>
    apiClient.get(`${API_BASE}/by-template/${id_template_goc}`),
  selectActive: () => apiClient.get(`${API_BASE}/active`),
  create: (request: IMauPhieuThuCauHinhCreateRequest) =>
    apiClient.post(API_BASE, request),
  update: (request: IMauPhieuThuCauHinhUpdateRequest) =>
    apiClient.put(API_BASE, request),
  delete: (id: number) => apiClient.delete(`${API_BASE}/${id}`),

  // Áp dụng theo loại + khoảng ngày
  apDungByMau: (id_mau_phieu_thu: number) =>
    apiClient.get(`${API_BASE}/ap-dung/by-mau/${id_mau_phieu_thu}`),
  apDungInsert: (request: IMauPhieuThuApDungRequest) =>
    apiClient.post(`${API_BASE}/ap-dung`, request),
  apDungDelete: (id_ap_dung: number) =>
    apiClient.delete(`${API_BASE}/ap-dung/${id_ap_dung}`),
};
